import { apiService } from './index';

// Inport types
import { ISelectType } from '../shared/types/select-type';

export const asyncGetRequestClassifications = async (): Promise<
    ISelectType[]
> => {
    const { items }: any = await apiService.get(`/api/request-classification`);
    return items || [];
};

export const asyncGetRequestClassificationsByCode = async (
    code: string
): Promise<ISelectType> => {
    const { items }: any = await apiService.get(
        `/api/request-classification/by-code/${code}`
    );
    return items;
};
